import { useEffect, useState } from "react";
import { cotAxios } from "./api";

/**
 * Hook para expor o usuário logado do Sistema de Cotações e helpers de papel.
 * - admin/super_admin: acesso total (cria, edita, aprova, exclui e gerencia acessos).
 * - comprador: cria/edita/aprova, mas não pode excluir cadastros nem gerenciar acessos.
 * - auditor: somente visualização + download de PDFs.
 */
export default function useCotacaoUser() {
  const readLocal = () => {
    try {
      const raw = localStorage.getItem("cotacao_user");
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  };

  const [user, setUser] = useState(readLocal);

  useEffect(() => {
    // Refresh silencioso — útil quando um admin promove/rebaixa o usuário.
    let ativo = true;
    cotAxios
      .get("/cotacao/auth/me")
      .then(({ data }) => {
        if (!ativo) return;
        localStorage.setItem("cotacao_user", JSON.stringify(data));
        setUser(data);
      })
      .catch(() => {});
    return () => {
      ativo = false;
    };
  }, []);

  const tipo = (user?.tipo || "admin").toLowerCase();
  const isSuper = !!user?.super_admin;
  const isAdmin = tipo === "admin" || isSuper;
  const isComprador = tipo === "comprador";
  const isAuditor = tipo === "auditor";
  const canWrite = isAdmin || isComprador; // cria/edita/aprova
  const canDelete = isAdmin; // exclui cadastros
  const canManageAccess = isAdmin;

  return {
    user,
    tipo,
    isAdmin,
    isComprador,
    isAuditor,
    canWrite,
    canDelete,
    canManageAccess,
  };
}
